"use strict";

define('components/portal_investments',['components/ajax'], function(ajax) {
    var portal_investments = {
        init: function(module) {
            var updateTabToDisplay = function(tab) {
                var formData = new FormData();
                formData.append('tab', tab);
                ajax('/portal/update_investments_tab',{
                        formData: formData});
            }
            module.find("#by-account-link").click(function(){
                 updateTabToDisplay('group_by_account')
            });
            module.find("#by-investment-link").click(function(){
                 updateTabToDisplay('group_by_investment')
            });
        }
    };

    return portal_investments;
});
